import { SxProps, Theme } from "@mui/material";

export const datePickerModalStyles = {
    checkAvailabilityText: (theme: Theme): SxProps<Theme> => ({
        fontSize: 24,
        fontFamily: theme.typography.fontFamily,
        fontWeight: 700,
        marginBottom: 1,
    }),
    calendarBox: {
        paddingBottom: 0.5,
        display: "flex",
        flexDirection: "row",
        alignItems: "end",
        gap: 3,
    },
    datePickerBox: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-start",
        alignItems: "center",
        paddingBottom: 0.5,
        backgroundColor: "white",
        padding: "13px 2px 7px 2px",
        borderBottom: "1px solid",
        borderColor: "#000",
        cursor: "pointer",
    },
    dateText: (theme: Theme): SxProps<Theme> => ({
        fontSize: "20px",
        fontFamily: theme.typography.fontFamily,
        fontWeight: 500,
        color: "#000",
        marginLeft: "10px",
        marginRight: "15px",
    }),
    dropdownIcon: {
        width: "8px", height: "8px"
    },
    timePickerBox: {
        flex: 1,
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        boxShadow: "0px 0px 4px 0px rgba(0, 0, 0, 0.25)",
    },
    selectBox: {
        width: "100%",
    },
    formControl: {
        width: "100%",
    },
    selectInputTime: {
        borderRadius: "8px",
        backgroundColor: "white",
        border: "none",
        "& .MuiOutlinedInput-input": {
            padding: "13px 8px",
        },
        "& .MuiOutlinedInput-notchedOutline": {
            border: "none",
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
            border: "none",
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            border: "none",
        },
        ".css-11bgdin-MuiSelect-icon": {
            top: "unset",
        },
        "& .MuiSelect-icon": {
            fontSize: "1.5rem",
            width: "12px",
            height: "7px",
        },
    },
    ticketBox: (availability: any) => ({
        marginTop: availability?.private ? 0 : 1,
    }),
    ticketHeading: (theme: Theme) => ({
        fontWeight: 500,
        fontSize: 18,
        mb: 0.5,
        fontFamily: theme.typography.fontFamily
    }),
    ticketFormControl: {
        flexDirection: "row",
        borderRadius: "8px",
        boxShadow: "0px 0px 4px 0px rgba(0, 0, 0, 0.25)",
    },
    ticketSelectBox: {
        display: "flex",
        alignItems: "center",
        borderTopLeftRadius: "8px",
        borderTopRightRadius: "0px",
        borderBottomLeftRadius: "8px",
        borderBottomRightRadius: "0px",
        padding: "0px 8px",
        width: "80%",
        justifyContent: "space-between",
        backgroundColor: "white",
        borderRight: 3,
        borderColor: "#E8E8EB",
    },
    unitNameText: {
        flexGrow: 1,
        fontSize: 15,
        fontWeight: "600",
    },
    availableText: {
        flexGrow: 1,
        fontSize: 13,
        fontWeight: "400",
    },
    priceText: {
        marginRight: 2,
    },
    ticketSelectControl: {
        width: "20%",
    },
    selectInputTicket: {
        minWidth: "60px",
        backgroundColor: "white",
        border: "none", // Remove outer border
        "& .MuiOutlinedInput-notchedOutline": {
            border: "none", // Remove Select's default border
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
            border: "none", // Remove border on hover
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            border: "none", // Remove border when focused
        },
        ".css-11bgdin-MuiSelect-icon": {
            top: "unset",
        },
    },
    priceDescriptionText: (theme: Theme) => ({
        fontWeight: 400,
        fontSize: 13,
        marginTop: 1,
        fontFamily: theme.typography.fontFamily,
    }),
    calendarDialog: {
        "& .MuiDialog-paper": {
            borderRadius: "8px",
        },
    },
    dialogHeader: (theme: Theme) => ({
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        px: 2,
        py: 1,
        borderBottom: `1px solid ${theme.palette.divider}`,
    }),
    dateCalendar: {
        // Style for the header (Month and year text)
        "& .MuiPickersCalendarHeader-label": {
            fontSize: "20px",
            fontWeight: "500",
        },
        // Style for the navigation arrows
        "& .css-1vooibu-MuiSvgIcon-root": {
            fill: "rgb(0 0 0)",
        },
    },
    calendarContainer: {
        display: "flex",
        gap: 2,
        p: 2,
    },
    selectedDay: {
        backgroundColor: "#328734",
        color: "white",
        fontWeight: "bold",
        "&:hover": {
            backgroundColor: "#328734",
        },
    },
    customDay: (isToday: boolean): SxProps<Theme> => ({
        ...(isToday && {
            color: "#000",
            fontWeight: "bold",
            border: "none !important",
        }),
    }),

};
